import { Button } from '@app/components'
import { IStore } from '@app/redux'
import { auth, EMAIL_TEMPLATES, sendEmail } from '@app/services'
import axios from 'axios'
import { PlaidWidgetProps } from 'libs/types/collections/plaid-widget.props'
import Script from 'next/script'
import { useCallback, useEffect, useState } from 'react'
import { usePlaidLink } from 'react-plaid-link'
import { useSelector } from 'react-redux'

export const PlaidWidget: React.FC<PlaidWidgetProps> = ({ button, refresh }) => {
  const { user } = useSelector((state: IStore) => state)

  const [token, setToken] = useState(null)

  useEffect(() => {
    const createLinkToken = async () => {
      const authorization = await auth.currentUser.getIdToken()
      const response = await axios.post(
        '/api/plaid/create-link-token',
        {},
        {
          headers: {
            Authorization: authorization,
          },
        },
      )
      const { link_token } = await response.data
      setToken(link_token)
    }
    createLinkToken()
  }, [user])

  const onSuccess = useCallback(async (publicToken) => {
    const authorization = await auth.currentUser.getIdToken()
    await axios.post(
      '/api/plaid/exchange-public-token',
      {
        public_token: publicToken,
        fortressIdentityId: user.selectedEntityIdentityId ? user.selectedEntityIdentityId : user.fortressIdentityId,
      },
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: authorization,
        },
      },
    )
    refresh()
    sendEmail(EMAIL_TEMPLATES.BANK_ACCOUNT_ADDED, user.email)
  }, [])

  const { open, ready } = usePlaidLink({
    token,
    onSuccess,
  })

  return (
    <>
      <Button {...button} onClick={() => open()} disabled={!ready}>
        {button?.title || 'Link account'}
      </Button>
      <Script src="https://cdn.plaid.com/link/v2/stable/link-initialize.js" />
    </>
  )
}
